export const AUTH_TERMS_URL = '/nutzungsbedingungen';
export const AUTH_PRIVACY_URL = '/datenschutz';
export const AUTH_IMPRINT_URL = '/impressum';

export const AUTH_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/marketing-assets/VisiMe_Logo_RGB-1.png`;
